export default class SetPasswordRequest {
    public password: string;

    constructor(password: string) {
        this.password = password;
    }
}